/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseCompany } from '../../models/api-response-company';

export interface UpdateCompanyLogo1$Params {
  ref: string;
  'x-api-requestId': string;
  'x-api-canal': string;
      body?: {
'companyLogo': Blob;
}
}

export function updateCompanyLogo1(http: HttpClient, rootUrl: string, params: UpdateCompanyLogo1$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCompany>> {
  const rb = new RequestBuilder(rootUrl, updateCompanyLogo1.PATH, 'put');
  if (params) {
    rb.path('ref', params.ref, {});
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseCompany>;
    })
  );
}

updateCompanyLogo1.PATH = '/v1/api/admin-ui/company/media/{ref}';
